import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AppStrings from '../config/appstring';

const PendingStudentList = ({user}) => {
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [feeDetails, setFeeDetails] = useState([]);
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    
console.log("Logged in as:", user?.name);
    fetchStudentData();
  }, [user]);

  const fetchStudentData = async () => {
    try {
      const response = await axios.get(AppStrings.PendingFeeDetails);
      const result = response.data.data.result || response.data.data;

      if (Array.isArray(result)) {
        setData(result);
        setError('');
      } else {
        setError('Unexpected response format');
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handlePayClick = async (row) => {
    const feeType = row.ADDFEES;
    const className = row.CLASS;
    const AdmissionID = row.STUDENT_ID;
    const type = 'N';

    if (!feeType || !className) {
      alert('Missing class or fee type');
      return;
    }

    const url = `${AppStrings.FeesDetailGet}?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}&ADMISSIONID=${AdmissionID}`;

    try {
      const response = await axios.get(url);
      const result = response.data.data.result || response.data.data;

      if (Array.isArray(result)) {
        const withEditable = result.map(item => ({ ...item, current: '', discount: '' }));
        setSelectedRow(row);
        setFeeDetails(withEditable);
      } else {
        alert(`No fee data found for ${row.NAME}`);
      }
    } catch (err) {
      alert("Failed to fetch fee details");
    }
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel = () => {
    setSelectedRow(null);
    setFeeDetails([]);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);

  const handleSubmit = async () => {
    const payload = {
      student: {
        id: selectedRow.STUDENT_ID,
        admissionDate,
        type: selectedRow.ADDFEES,
      },
      fees: feeDetails
        .filter(({ current, discount }) => (parseFloat(current) || 0) + (parseFloat(discount) || 0) > 0)
        .map(({ TYPE, FEES, current, discount }) => ({
          TYPE, FEES, current, discount
        }))
    };

    try {
      const res = await fetch(AppStrings.StudentFeesEntry, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await res.json();
      alert(result.message || "Data saved successfully!");
      handleCancel();
      fetchStudentData();
    } catch (err) {
      alert("Failed to save data");
    }
  };

  return (
    <div style={{ padding: '10px' }}>
      <h2>Pending Student List</h2>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <input
        type="text"
        placeholder="Search by Student Name or ID"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginBottom: '10px', padding: '6px', width: '300px' }}
      />

      <div style={{ overflowX: 'auto', maxHeight: '400px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#f2f2f2' }}>
              {["Student ID", "Name", "Class-Sec", "Phone", "Class", "Type", "Tuition Due", "Transport Due", "Actions"].map(h => (
                <th key={h} style={headerCellStyle}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data
              .filter(row =>
                row.NAME.toLowerCase().includes(search.toLowerCase()) ||
                row.STUDENT_ID.toLowerCase().includes(search.toLowerCase()))
              .map((row, idx) => (
                <tr key={idx}>
                  <td style={cellStyle}>{row.STUDENT_ID}</td>
                  <td style={cellStyle}>{row.NAME}</td>
                  <td style={cellStyle}>{row.CLASS_SEC}</td>
                  <td style={cellStyle}>{row.PHONE}</td>
                  <td style={cellStyle}>{row.CLASS}</td>
                  <td style={cellStyle}>{row.ADDFEES}</td>
                  <td style={cellStyle}>{row.TUITION_DUE}</td>
                  <td style={cellStyle}>{row.TRANSPORT_DUE}</td>
                  <td style={cellStyle}>
                    <button className="GridButton" onClick={() => handlePayClick(row)}>Pay</button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* Sliding Panel */}
      <div style={{
        ...slidePanelStyle,
        right: selectedRow ? '0px' : '-100%',
      }}>
        {selectedRow && (
          <>
            <h3>{selectedRow.STUDENT_ID} - {selectedRow.NAME}</h3>
            <p><strong>Class:</strong> {selectedRow.CLASS}</p>

            <label>Admission Date:</label>
            <input
              type="date"
              value={admissionDate}
              onChange={(e) => setAdmissionDate(e.target.value)}
              style={{ marginBottom: '10px', width: '100%' }}
            />

            {feeDetails.length > 0 ? (
              <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                <thead>
                  <tr>
                    <th style={headerCellStyle}>Type</th>
                    <th style={headerCellStyle}>Amount</th>
                    <th style={headerCellStyle}>Discount</th>
                    <th style={headerCellStyle}>Paid</th>
                  </tr>
                </thead>
                <tbody>
                  {feeDetails.map((fee, i) => (
                    <tr key={i}>
                      <td style={cellStyle}>{fee.TYPE}</td>
                      <td style={cellStyle}>{fee.FEES}</td>
                      <td style={cellStyle}>
                        <input
                          type="text"
                          value={fee.discount}
                          placeholder="Discount"
                          onChange={(e) => handleInputChange(i, 'discount', e.target.value)}
                          style={{ width: '60px' }}
                        />
                      </td>
                      <td style={cellStyle}>
                        <input
                          type="text"
                          value={fee.current}
                          placeholder="Paid"
                          onChange={(e) => handleInputChange(i, 'current', e.target.value)}
                          style={{ width: '60px' }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No fee details available.</p>
            )}

            <div style={{ marginTop: '10px', textAlign: 'right' }}>
              <strong>Total Paid: ₹{totalPaid.toFixed(2)}</strong>
            </div>

            <div style={{ marginTop: '15px' }}>
              <button onClick={handleSubmit}>Save</button>
              <button onClick={handleCancel} style={{ marginLeft: '10px' }}>Close</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// Styles
const headerCellStyle = {
  border: '1px solid #ccc',
  padding: '6px',
  fontSize: '13px',
  backgroundColor: '#f9f9f9',
};

const cellStyle = {
  border: '1px solid #ddd',
  padding: '6px',
  fontSize: '13px'
};

const slidePanelStyle = {
  position: 'fixed',
  top: 0,
  right: '-100%',
  width: '400px',
  height: '100%',
  backgroundColor: '#fff',
  boxShadow: '-2px 0 10px rgba(0,0,0,0.3)',
  padding: '20px',
  overflowY: 'auto',
  transition: 'right 0.3s ease-in-out',
  zIndex: 1000,
};

export default PendingStudentList;
